import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvCategoriesEditor.html?raw';
import "../EvBookingEditorTypes";
import '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";

class EvCategoriesEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;
    categoryInput: MdsLax<InstanceType<typeof HintBox>>;


    _onChangeInput(): void {
        let value = this.categoryInput.getValue();

        if (value != null) {
            this.emit("added", value, [EvBookingEditor_ListNames.evCategories]);
            this.categoryInput.setValue(null)
        }
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.categoryInput.enablePlainTextValue = false;

        this.domNode.addEventListener('click', function (evt) {
            evt.stopPropagation();
        });
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvCategoriesEditor);